<template>
  <div class="txt_pop">
    <!-- <div class="text">
      <h4>{{$t("message.txtpop.h4")}}</h4>
      <p>
       {{$t("message.home.res_p1")}}
      </p>
      <p>
         {{$t("message.home.res_p1")}}
      </p>
      <p>
         {{$t("message.home.res_p1")}}
      </p>
      <p>
          {{$t("message.home.res_p1")}}
      </p>
      <p>  {{$t("message.home.res_p1")}}。</p>
      <p>  {{$t("message.home.res_p1")}}</p>
      <p>
         {{$t("message.home.res_p1")}}
      </p>
      <p>
       
      </p>
    </div> -->

    <div class="text">
      <h4>{{ $t('message.txtpop.h4') }}</h4>
      <p>
        {{ $t('message.txtpop.res_p1') }}
      </p>
      <p>
        {{ $t('message.txtpop.res_p2') }}
      </p>
      <p>
        {{ $t('message.txtpop.res_p3') }}
      </p>
      <p>
        {{ $t('message.txtpop.res_p4') }}
      </p>
      <p>{{ $t('message.txtpop.res_p5') }}。</p>
    </div>
    <div class="remove" @click="$emit('ResponsTextClose', false)">
      <van-icon name="cross" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ResponsText',
}
</script>

<style lang="less" scoped>
.txt_pop {
  width: 100%;
  overflow: hidden;
  box-sizing: border-box;
  padding: 32px;

  h4 {
    text-align: center;
    font-size: 18px;
    color: #1a1a1a;
    font-weight: 500;
  }

  p {
    margin: 10px 0;
    font-size: 14px;
    color: #1a1a1a;
  }
}
.remove {
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  right: 10px;
  top: 10px;
}
</style>
